import React from 'react';
import { pressLogos } from '../data/press';
export function PressMarquee({
  label = 'As featured in'
}: {
  label?: string;
}) {
  const row = [...pressLogos, ...pressLogos];
  return <section className="border-b border-charcoal/[0.08] py-12" data-id="element-130" data-mp="18nxm9ao7x4vk">
      <p className="eyebrow px-6 text-center text-charcoal/35 sm:px-10" data-id="element-131" data-mp="18oh30o24tn80">{label}</p>
      <div className="marquee-mask mt-8 overflow-hidden" data-id="element-132" data-mp="1dm8w3leijfds">
        <div className="animate-marquee flex w-max items-center gap-16 pr-16" data-id="element-133" data-mp="fzimfvdnqt4t">
          {row.map((logo, i) => <span key={`${logo}-${i}`} className="whitespace-nowrap font-serif text-lg tracking-[0.22em] text-charcoal/35 sm:text-xl" data-id="element-134" data-mp="kxbnka03swy8" data-mpi={i}>
              {logo}
            </span>)}
        </div>
      </div>
    </section>;
}